import React from 'react';
import classNames from 'classnames';
import { Button, Checkbox, Paper, Translation } from '../../common';
import StatisticFilter from '../StatisticFilter/index.troy';

export default ({
  styles,
  className,
  filterOptions,
  filterValues,
  groups,
  onOptionChange,
  onFilterClick,
  onTypeFilterChange,
  chosenStatisticFilter,
  buttonClassName,
}) => {
  return (
    <Paper className={classNames(styles['filter__wrapper'], className)}>
      <Translation className={styles['filter__form-title']}>
        FILTER_PANEL_HEADER
      </Translation>
      <div className={styles['filter__form']}>
        <div className={styles['filter__form-parameters']}>
          <div className={styles['filter__statistic-parameter']}>
            <StatisticFilter
              groups={groups}
              onTypeChange={onTypeFilterChange}
              chosenStatisticFilter={chosenStatisticFilter}
            />
          </div>
          <div className={styles['filter__dash']} />
          {filterOptions && filterOptions.length && (
            <div className={styles['filter__switchers']}>
              {filterOptions.map(({ label, name }, key) => (
                <Checkbox
                  id={`page.postbox.component.filter.${name}-checkbox`}
                  className={styles['filter__checkboxes-bills']}
                  classNameChecked={styles['filter__checkboxes-bills_checked']}
                  classNameWrapper={styles['filter__checkboxes-wrapper']}
                  classNameTranslation={
                    styles['filter__checkboxes-translation']
                  }
                  {...{ label, key }}
                  value={filterValues[name]}
                  onClick={onOptionChange(name)}
                  translated
                />
              ))}
            </div>
          )}
        </div>
        <Button
          id="page.postbox.component.filter.filter-button"
          onClick={onFilterClick}
          className={classNames(styles['filter__button'], buttonClassName)}
        >
          <Translation>FILTER_APPLY</Translation>
        </Button>
      </div>
    </Paper>
  );
};
